module.exports = __webpack_public_path__ + "card1.jpg?348d8be7f2b957be803d34677f15c643";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/card1.jpg
// module id = 124
// module chunks = 0